import _ from 'lodash';
import * as formatter from '../../_config/formatter';
import * as RestService from '../../_config/rest';
import { saveDataToLocalStorage } from '../../_config/utils';
import { ctx as L20NContext, Entity } from '@sketchpixy/rubix/lib/L20n';
import FileSaver from 'file-saver';
import moment from 'moment';
import React from 'react';
import * as XLSX from 'xlsx';
import { BACKGROUND_TASK_TYPES, EXPORT_FORMATS, SUBSCRIPTION_TYPES, VIRTUAL_INTERCOM_EXTENSION_VISIBILITY, VIRTUAL_INTERCOM_MANAGEMENT_LIMITS, VIRTUAL_INTERCOM_VIEW_MODES_PARAMETERS } from '../../_config/consts';
import * as UtilsActions from './utils.actions';
import * as ModalActions from './modal.actions';
import {
  APPEND_EXTENSION_GROUPS,
  APPEND_EXTENSION_USERS_FILTERED_BY_TAGS,
  APPEND_EXTENSIONS,
  APPEND_HYPER_TILES,
  APPEND_INTERCOM_EXTENSIONS,
  APPEND_INTERCOM_LOCKS_FILTERED_BY_TAGS,
  APPEND_INTERCOMS,
  CANCEL_FETCH_EXTENSION_USERS_BY_TAGS,
  CANCEL_FETCH_INTERCOM_LOCKS_BY_TAGS,
  FETCH_EXTENSION_USERS_BY_TAGS,
  FETCH_INTERCOM_LOCKS_BY_TAGS,
  RESET_EXTENSION_GROUPS_PAGINATION_DATA,
  RESET_EXTENSIONS_FILTERS,
  RESET_EXTENSIONS_PAGINATION_DATA,
  RESET_HYPER_TILES_PAGINATION_DATA,
  RESET_INTERCOM_EXTENSIONS_PAGINATION_DATA,
  RESET_INTERCOMS_FILTERS,
  RESET_INTERCOMS_PAGINATION_DATA,
  SAVE_ALL_EXTENSIONS,
  SAVE_EXTENSION_GROUPS,
  SAVE_EXTENSIONS,
  SAVE_HYPER_TILES,
  SAVE_INTERCOM_EXTENSIONS,
  SAVE_INTERCOMS,
  SAVE_VIRTUAL_INTERCOM_LIMITS,
  SELECT_EXTENSION,
  SELECT_HYPER_TILE,
  SELECT_INTERCOM,
  SET_EXTENSION_FILTER,
  SET_EXTENSION_GROUPS_PAGINATION_DATA,
  SET_EXTENSION_OPERATIONAL_MODE,
  SET_EXTENSION_ORDER,
  SET_EXTENSION_USERS_FILTERED_BY_TAGS,
  SET_EXTENSION_USERS_FILTERED_BY_TAGS_PAGINATION_DATA,
  SET_EXTENSIONS_PAGINATION_DATA,
  SET_HYPER_TILES_PAGINATION_DATA,
  SET_INTERCOM_EXTENSIONS_PAGINATION_DATA,
  SET_INTERCOM_FILTER,
  SET_INTERCOM_LOCKS_FILTERED_BY_TAGS,
  SET_INTERCOM_LOCKS_FILTERED_BY_TAGS_PAGINATION_DATA,
  SET_INTERCOM_OPERATIONAL_MODE,
  SET_INTERCOM_ORDER,
  SET_INTERCOMS_PAGINATION_DATA,
  UPDATE_EXTENSION,
  UPDATE_EXTENSION_GROUP,
  UPDATE_HYPER_TILE,
  UPDATE_INTERCOM,
} from './actionTypes/intercom';

export function saveIntercoms(intercoms) {
  return {
    type: SAVE_INTERCOMS,
    intercoms
  };
}

export function appendIntercoms(intercoms) {
  return {
    type: APPEND_INTERCOMS,
    intercoms
  };
}

export function setIntercomsPaginationData(pagination) {
  return {
    type: SET_INTERCOMS_PAGINATION_DATA,
    pagination,
  };
}

export function resetIntercomsPaginationData() {
  return {
    type: RESET_INTERCOMS_PAGINATION_DATA,
  };
}

export function selectIntercom(intercom) {
  return {
    type: SELECT_INTERCOM,
    intercom,
  };
}

export function resetIntercomFilters() {
  return { type: RESET_INTERCOMS_FILTERS };
}

export function setIntercomOperationalMode(value) {
  return {
    type: SET_INTERCOM_OPERATIONAL_MODE,
    value,
  };
}

export function setIntercomFilter(name, value) {
  return {
    type: SET_INTERCOM_FILTER,
    name,
    value,
  };
}

export function updateIntercomOnState(intercom) {
  return {
    type: UPDATE_INTERCOM,
    intercom,
  };
}

export function setOrder(orderBy, orderDir) {
  return {
    type: SET_INTERCOM_ORDER,
    orderBy,
    orderDir,
  };
}

export function saveExtensionGroups(groups) {
    return {
      type: SAVE_EXTENSION_GROUPS,
      groups
    };
  }
  
export function appendExtensionGroups(groups) {
    return {
      type: APPEND_EXTENSION_GROUPS,
      groups
    };
}
  
export function setExtensionGroupsPaginationData(pagination) {
    return {
      type: SET_EXTENSION_GROUPS_PAGINATION_DATA,
      pagination,
    };
}
  
export function resetExtensionGroupsPaginationData() {
    return {
      type: RESET_EXTENSION_GROUPS_PAGINATION_DATA,
    };
}
  
export function updateExtensionGroupOnState(group) {
    return {
      type: UPDATE_EXTENSION_GROUP,
      group,
    };
}

export function saveExtensions(extensions) {
  return {
    type: SAVE_EXTENSIONS,
    extensions
  };
}

export function appendExtensions(extensions) {
  return {
    type: APPEND_EXTENSIONS,
    extensions
  };
}

export function setExtensionsPaginationData(pagination) {
  return {
    type: SET_EXTENSIONS_PAGINATION_DATA,
    pagination,
  };
}

export function resetExtensionsPaginationData() {
  return {
    type: RESET_EXTENSIONS_PAGINATION_DATA,
  };
}

export function selectExtension(extension) {
  return {
    type: SELECT_EXTENSION,
    extension,
  };
}

export function updateExtensionOnState(extension) {
  return {
    type: UPDATE_EXTENSION,
    extension,
  };
}

export function setExtensionOperationalMode(value) {
  return {
    type: SET_EXTENSION_OPERATIONAL_MODE,
    value,
  };
}

export function resetExtensionsFilters() {
  return { type: RESET_EXTENSIONS_FILTERS };
}

export function setExtensionFilter(name, value) {
  return {
    type: SET_EXTENSION_FILTER,
    name,
    value,
  };
}

export function setExtensionOrder(orderBy, orderDir) {
  return {
    type: SET_EXTENSION_ORDER,
    orderBy,
    orderDir,
  };
}

export function saveIntercomExtensions(extensions) {
  return {
    type: SAVE_INTERCOM_EXTENSIONS,
    extensions
  };
}

export function appendIntercomExtensions(extensions) {
  return {
    type: APPEND_INTERCOM_EXTENSIONS,
    extensions
  };
}

export function setIntercomExtensionsPaginationData(pagination) {
  return {
    type: SET_INTERCOM_EXTENSIONS_PAGINATION_DATA,
    pagination,
  };
}

export function resetIntercomExtensionsPaginationData() {
  return {
    type: RESET_INTERCOM_EXTENSIONS_PAGINATION_DATA,
  };
}

export function saveHyperTiles(tiles) {
  return {
    type: SAVE_HYPER_TILES,
    tiles
  };
}

export function appendHyperTiles(tiles) {
  return {
    type: APPEND_HYPER_TILES,
    tiles
  };
}

export function setHyperTilesPaginationData(pagination) {
  return {
    type: SET_HYPER_TILES_PAGINATION_DATA,
    pagination,
  };
}

export function resetHyperTilesPaginationData() {
  return {
    type: RESET_HYPER_TILES_PAGINATION_DATA,
  };
}

export function selectHyperTile(tile) {
  return {
    type: SELECT_HYPER_TILE,
    tile,
  };
}

export function updateHyperTileOnState(tile) {
  return {
    type: UPDATE_HYPER_TILE,
    tile,
  };
}

export function saveAllExtensions(extensions) {
  return {
    type: SAVE_ALL_EXTENSIONS,
    extensions
  };
}

export function cancelFetchIntercomLocksByTags() {
  return {
    type: CANCEL_FETCH_INTERCOM_LOCKS_BY_TAGS,
  };
}

export function fetchIntercomLocksByTags(tags, lockTagMatchingMode, page = 0, append = false, index = 0) {
  return {
    type: FETCH_INTERCOM_LOCKS_BY_TAGS,
    tags,
    index,
    lockTagMatchingMode,
    page,
    append,
  };
}

export function setIntercomLocksFilteredByTags(locks, index = 0) {
  return {
    type: SET_INTERCOM_LOCKS_FILTERED_BY_TAGS,
    index: index,
    locks,
  };
}

export function appendIntercomLocksFilteredByTags(locks, index = 0) {
  return {
    type: APPEND_INTERCOM_LOCKS_FILTERED_BY_TAGS,
    index: index,
    locks,
  };
}

export function setIntercomLocksFilteredByTagsPaginationData(pagination, index) {
  return {
    type: SET_INTERCOM_LOCKS_FILTERED_BY_TAGS_PAGINATION_DATA,
    index: index || 0,
    pagination,
  };
}

export function setIntercomLocksFilteredByTagsEpic(locks, index, pagination, append = false) {
  return (dispatch, getState) => {
    if (append) {
      dispatch(appendIntercomLocksFilteredByTags(locks, index));
    } else {
      dispatch(setIntercomLocksFilteredByTags(locks, index));
    }
    dispatch(setIntercomLocksFilteredByTagsPaginationData(pagination, index));
  };
}

export function cancelFetchExtensionUsersByTags() {
  return {
    type: CANCEL_FETCH_EXTENSION_USERS_BY_TAGS,
  };
}

export function fetchExtensionUsersByTags(tags, userTagMatchingMode, page = 0, append = false, index = 0) {
  return {
    type: FETCH_EXTENSION_USERS_BY_TAGS,
    tags,
    index,
    userTagMatchingMode,
    page,
    append,
  };
}

export function setExtensionUsersFilteredByTags(users, index = 0) {
  return {
    type: SET_EXTENSION_USERS_FILTERED_BY_TAGS,
    index: index,
    users,
  };
}

export function appendExtensionUsersFilteredByTags(users, index = 0) {
  return {
    type: APPEND_EXTENSION_USERS_FILTERED_BY_TAGS,
    index: index,
    users,
  };
}

export function setExtensionUsersFilteredByTagsPaginationData(pagination, index) {
  return {
    type: SET_EXTENSION_USERS_FILTERED_BY_TAGS_PAGINATION_DATA,
    index: index || 0,
    pagination,
  };
}

export function setExtensionUsersFilteredByTagsEpic(users, index, pagination, append = false) {
  return (dispatch, getState) => {
    if (append) {
      dispatch(appendExtensionUsersFilteredByTags(users, index));
    } else {
      dispatch(setExtensionUsersFilteredByTags(users, index));
    }
    dispatch(setExtensionUsersFilteredByTagsPaginationData(pagination, index));
  };
}

export function fetchIntercoms(page = 0, append = false, pageSize = 20) {
  return async (dispatch, getState) => {
    try {
      const filters = structuredClone(getState().intercom.data.filters);
      const orderBy = getState().intercom.data.sorting.orderBy;
      const orderDir = orderBy ? getState().intercom.data.sorting.orderDir : undefined;
      const params = {
        page,
        pageSize,
        ...filters,
        orderBy,
        orderDir,
      };
      const response = await RestService.fetchIntercoms(params);
      if (response.data && response.data.content) {
        const formattedIntercoms = _.map(response.data.content, intercom => formatter.formatInputData(formatter.INTERCOM, { ...intercom }));
        if (append) {
          dispatch(appendIntercoms(formattedIntercoms));
        } else {
          dispatch(saveIntercoms(formattedIntercoms));
        }
        dispatch(setIntercomsPaginationData(_.omit(response.data, 'content')));
        return formattedIntercoms;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function editIntercom(intercomId, data) {
  return async (dispatch, getState) => {
    try {
      const formattedData = formatter.formatOutputData(formatter.INTERCOM, data);
      const response = await RestService.editIntercom(intercomId, formattedData);
      if (response && response.data) {
        const formattedIntercom = formatter.formatInputData(formatter.INTERCOM, { ...response.data });
        dispatch(updateIntercomOnState({
          ...formattedIntercom
        }));
        return formattedIntercom;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function createIntercom(data) {
  return async (dispatch, getState) => {
    try {
      const formattedData = formatter.formatOutputData(formatter.INTERCOM, data);
      const response = await RestService.createIntercom(formattedData);
      if (response && response.data) {
        const formattedIntercom = formatter.formatInputData(formatter.INTERCOM, { ...response.data });
        return formattedIntercom;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function deleteIntercom(intercomId) {
  return async (dispatch, getState) => {
    try {
      const response = await RestService.deleteIntercom(intercomId);
      if (response)
        return response;
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function fetchIntercomDetails(intercomId) {
  return async (dispatch, getState) => {
    try {
      const response = await RestService.fetchIntercomDetails(intercomId);
      if (response && response.data) {
        const formattedIntercom = formatter.formatInputData(formatter.INTERCOM, { ...response.data });
        dispatch(selectIntercom(formattedIntercom));
        return formattedIntercom;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function fetchIntercomExtensions(intercomId, page = 0, append = false, pageSize = 20) {
  return async (dispatch, getState) => {
    try {
        const params = {
            page,
            pageSize,
        };
        const response = await RestService.fetchIntercomExtensions(intercomId, params);
        if (response && response.data) {
            const formattedExtensions = _.map(response.data.content, extension => formatter.formatInputData(formatter.INTERCOM_EXTENSION, { ...extension }));
            if (append) {
                dispatch(appendIntercomExtensions(formattedExtensions));
            } else {
                dispatch(saveIntercomExtensions(formattedExtensions));
            }
            dispatch(setIntercomExtensionsPaginationData(_.omit(response.data, 'content')));
            return formattedExtensions;
        }
        throw new Error();
        } catch (error) {
            throw new Error(error);
        }
  };
}

export function fetchExtensions(page = 0, append = false, pageSize = 20) {
  return async (dispatch, getState) => {
    try {
      const filters = structuredClone(getState().intercom.extensions.filters);
      const orderBy = getState().intercom.extensions.sorting.orderBy;
      const orderDir = orderBy ? getState().intercom.extensions.sorting.orderDir : undefined;
      const params = {
        page,
        pageSize,
        ...filters,
        orderBy,
        orderDir,
        onlyMyExtensions: false,
      };
      const response = await RestService.fetchExtensions(params);
      if (response.data && response.data.content) {
        const formattedExtensions = _.map(response.data.content, extension => formatter.formatInputData(formatter.INTERCOM_EXTENSION, { ...extension }));
        if (append) {
          dispatch(appendExtensions(formattedExtensions));
        } else {
          dispatch(saveExtensions(formattedExtensions));
        }
        dispatch(setExtensionsPaginationData(_.omit(response.data, 'content')));
        return formattedExtensions;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function createExtension(data) {
  return async (dispatch, getState) => {
    try {
      const formattedData = formatter.formatOutputData(formatter.INTERCOM_EXTENSION, data);
      const response = await RestService.createExtension(formattedData);
      if (response && response.data) {
        const formattedExtension = formatter.formatInputData(formatter.INTERCOM_EXTENSION, { ...response.data });
        return formattedExtension;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function editExtension(extensionId, data) {
  return async (dispatch, getState) => {
    try {
      const formattedData = formatter.formatOutputData(formatter.INTERCOM_EXTENSION, data);
      const response = await RestService.editExtension(extensionId, formattedData);
      if (response && response.data) {
        const formattedExtension = formatter.formatInputData(formatter.INTERCOM_EXTENSION, { ...response.data });
        dispatch(updateExtensionOnState({
          ...formattedExtension
        }));
        return formattedExtension;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function deleteExtension(extensionId) {
  return async (dispatch, getState) => {
    try {
      const response = await RestService.deleteExtension(extensionId);
      if (response)
        return response;
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function fetchExtensionDetails(extensionId) {
  return async (dispatch, getState) => {
    try {
      const response = await RestService.fetchExtensionDetails(extensionId);
      if (response && response.data) {
        const formattedExtension = formatter.formatInputData(formatter.INTERCOM_EXTENSION, { ...response.data });
        dispatch(selectExtension(formattedExtension));
        return formattedExtension;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function fetchExtensionGroups(page = 0, append = false, pageSize = 1000) {
  return async (dispatch, getState) => {
    try {
      const params = {
        page,
        pageSize
      };
      const response = await RestService.fetchExtensionGroups(params);
      if (response.data && response.data.content) {
        const formattedGroups = _.map(response.data.content, group => formatter.formatInputData(formatter.INTERCOM_EXTENSION_GROUP, { ...group }));
        if (append) {
          dispatch(appendExtensionGroups(formattedGroups));
        } else {
          dispatch(saveExtensionGroups(formattedGroups));
        }
        dispatch(setExtensionGroupsPaginationData(_.omit(response.data, 'content')));
        return formattedGroups;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function createExtensionGroup(data) {
  return async (dispatch, getState) => {
    try {
      const formattedData = formatter.formatOutputData(formatter.INTERCOM_EXTENSION_GROUP, data);
      const response = await RestService.createExtensionGroup(formattedData);
      if (response && response.data) {
        const formattedGroup = formatter.formatInputData(formatter.INTERCOM_EXTENSION_GROUP, { ...response.data });
        return formattedGroup;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function editExtensionGroup(groupId, data) {
  return async (dispatch, getState) => {
    try {
      const formattedData = formatter.formatOutputData(formatter.INTERCOM_EXTENSION_GROUP, data);
      const response = await RestService.editExtensionGroup(groupId, formattedData);
      if (response && response.data) {
        const formattedGroup = formatter.formatInputData(formatter.INTERCOM_EXTENSION_GROUP, { ...response.data });
        dispatch(updateExtensionGroupOnState({
          ...formattedGroup
        }));
        return formattedGroup;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function deleteExtensionGroup(groupId) {
  return async (dispatch, getState) => {
    try {
      const response = await RestService.deleteExtensionGroup(groupId);
      if (response)
        return response;
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function fetchHyperTiles(page = 0, append = false, pageSize = 20) {
  return async (dispatch, getState) => {
    try {
      const params = {
        page,
        pageSize,
      };
      const response = await RestService.fetchHyperTiles(params);
      if (response.data && response.data.content) {
        const formattedTiles = _.map(response.data.content, tile => formatter.formatInputData(formatter.INTERCOM_HYPER_TILE, { ...tile }));
        if (append) {
          dispatch(appendHyperTiles(formattedTiles));
        } else {
          dispatch(saveHyperTiles(formattedTiles));
        }
        dispatch(setHyperTilesPaginationData(_.omit(response.data, 'content')));
        return formattedTiles;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function fetchHyperTileDetails(hyperTileId) {
  return async (dispatch, getState) => {
    try {
      const response = await RestService.fetchHyperTileDetails(hyperTileId);
      if (response && response.data) {
        const formattedTile = formatter.formatInputData(formatter.INTERCOM_HYPER_TILE, { ...response.data });
        dispatch(selectHyperTile(formattedTile));
        return formattedTile;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function createHyperTile(data) {
  return async (dispatch, getState) => {
    try {
      const formattedData = formatter.formatOutputData(formatter.INTERCOM_HYPER_TILE, data);
      const response = await RestService.createHyperTile(formattedData);
      if (response && response.data) {
        const formattedTile = formatter.formatInputData(formatter.INTERCOM_HYPER_TILE, { ...response.data });
        return formattedTile;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function deleteHyperTile(hyperTileId) {
  return async (dispatch, getState) => {
    try {
      const response = await RestService.deleteHyperTile(hyperTileId);
      if (response)
        return response;
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function fetchAllExtensions() {
  return async (dispatch, getState) => {
    try {
      const params = {
        page: 0,
        pageSize: 1000,
        onlyMyExtensions: false,
      };
      const response = await RestService.fetchExtensions(params);
      if (response.data && response.data.content) {
        const formattedExtensions = _.map(response.data.content, extension => formatter.formatInputData(formatter.INTERCOM_EXTENSION, { ...extension }));
        dispatch(saveAllExtensions(formattedExtensions));
        return formattedExtensions;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function setIntercomViewMode(viewMode) {
  saveDataToLocalStorage('intercomViewMode', viewMode);
}

export function setExtensionViewMode(viewMode) {
  saveDataToLocalStorage('extensionViewMode', viewMode);
}

export function fetchAllIntercomsForExport(page = 0, pageSize = 100) {
  return async (dispatch, getState) => {
    const taskId = moment().valueOf();
    const filters = structuredClone(getState().intercom.data.filters);
    let stopFetching = false;
    dispatch(UtilsActions.addBackgroundTaskSingleton({
      id: taskId,
      type: BACKGROUND_TASK_TYPES.DOWNLOAD_INTERCOMS_CSV,
      title: 'creatingIntercomsExportFile',
      cancelCallback: () => {
        stopFetching = true;
      },
    }));
    try {
      let params = {
        page,
        pageSize,
        ...filters,
      };
      let intercomResponse = await RestService.fetchIntercoms(params);
      if (intercomResponse && intercomResponse.data && intercomResponse.data.content && !_.isEmpty(intercomResponse.data.content)) {
        let formattedIntercoms = _.map(intercomResponse.data.content, intercom => formatter.formatInputData(formatter.INTERCOM, intercom));
        const intercoms = [...formattedIntercoms];
        let pagination = _.omit(intercomResponse.data, 'content');
        while (pagination.number + 1 !== pagination.totalPages && !stopFetching) {
          params = {
            ...params,
            page: pagination.number + 1,
          };
          intercomResponse = await RestService.fetchIntercoms(params);
          formattedIntercoms = _.map(intercomResponse.data.content, intercom => formatter.formatInputData(formatter.INTERCOM, intercom));
          intercoms.push(...formattedIntercoms);
          pagination = _.omit(intercomResponse.data, 'data');
        }
        dispatch(UtilsActions.removeBackgroundTask(taskId));
        return { intercoms, stopFetching };
      }
      dispatch(UtilsActions.removeBackgroundTask(taskId));
      throw new Error();
    } catch (error) {
      dispatch(UtilsActions.removeBackgroundTask(taskId));
      throw error;
    }
  };
}

export function exportIntercoms(format = EXPORT_FORMATS.CSV) {
  return async (dispatch, getState) => {
    try {
      const { intercoms, stopFetching } = await dispatch(fetchAllIntercomsForExport());
      if (!stopFetching) {
        const exportData = [];
        _.each(intercoms, (intercom) => {
          exportData.push({
            Name: intercom.name,
            'Smart Locks Tags': _.map(intercom.smartLocks, smartLock => smartLock.name).join(', '),
            'Extension Groups': _.map(intercom.groups, group => group.name).join(', '),
            'Hyper Tiles': intercom && intercom.hyperTile && intercom.hyperTile.name || '---',
            'Enabled': intercom.enabled ? 'Yes' : 'No',
            'Display Mode': VIRTUAL_INTERCOM_VIEW_MODES_PARAMETERS[intercom.viewMode] && VIRTUAL_INTERCOM_VIEW_MODES_PARAMETERS[intercom.viewMode].label ? L20NContext.getSync(VIRTUAL_INTERCOM_VIEW_MODES_PARAMETERS[intercom.viewMode].label) : '---',
          });
        });
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = format.toLowerCase();
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = { Sheets: { intercoms: ws }, SheetNames: ['intercoms'] };
        const excelBuffer = XLSX.write(wb, { bookType: fileExtension, type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `Intercoms_Export.${fileExtension}`);
        return intercoms;
      } else {
        throw new Error();
      }
    } catch (error) {
      let errorMessage = 'errorCreatingCSV';
      if (error.message === 'TOO_MANY_TASKS_SAME_TYPE') errorMessage = 'taskAlreadyExecuting';
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
      throw new Error(error);
    }
  };
}

export function fetchAllExtensionsForExport(page = 0, pageSize = 100) {
  return async (dispatch, getState) => {
    const taskId = moment().valueOf();
    const filters = structuredClone(getState().intercom.extensions.filters);
    let stopFetching = false;
    dispatch(UtilsActions.addBackgroundTaskSingleton({
      id: taskId,
      type: BACKGROUND_TASK_TYPES.DOWNLOAD_EXTENSIONS_CSV,
      title: 'creatingExtensionsExportFile',
      cancelCallback: () => {
        stopFetching = true;
      },
    }));
    try {
      let params = {
        page,
        pageSize,
        ...filters,
        onlyMyExtensions: false,
      };
      let extensionResponse = await RestService.fetchExtensions(params);
      if (extensionResponse && extensionResponse.data && extensionResponse.data.content && !_.isEmpty(extensionResponse.data.content)) {
        let formattedExtensions = _.map(extensionResponse.data.content, extension => formatter.formatInputData(formatter.INTERCOM_EXTENSION, extension));
        const extensions = [...formattedExtensions];
        let pagination = _.omit(extensionResponse.data, 'content');
        while (pagination.number + 1 !== pagination.totalPages && !stopFetching) {
          params = {
            ...params,
            page: pagination.number + 1,
          };
          extensionResponse = await RestService.fetchExtensions(params);
          formattedExtensions = _.map(extensionResponse.data.content, extension => formatter.formatInputData(formatter.INTERCOM_EXTENSION, extension));
          extensions.push(...formattedExtensions);
          pagination = _.omit(extensionResponse.data, 'data');
        }
        dispatch(UtilsActions.removeBackgroundTask(taskId));
        return { extensions, stopFetching };
      }
      dispatch(UtilsActions.removeBackgroundTask(taskId));
      throw new Error();
    } catch (error) {
      dispatch(UtilsActions.removeBackgroundTask(taskId));
      throw error;
    }
  };
}

export function exportExtensions(format = EXPORT_FORMATS.CSV) {
  return async (dispatch, getState) => {
    try {
      const { extensions, stopFetching } = await dispatch(fetchAllExtensionsForExport());
      if (!stopFetching) {
        const exportData = [];
        _.each(extensions, (extension) => {
          exportData.push({
            Name: extension.name,
            'Extension Group': extension.group ? extension.group.name : '---',
            'Users': _.map(extension.users, user => `${user.firstname || '---'} ${user.lastname || '---'} (${user.email || '---'})`).join(', '),
            'Visibility': extension.visible && extension.visible === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE ? 'Yes' : 'No',
          });
        });
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = format.toLowerCase();
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = { Sheets: { extensions: ws }, SheetNames: ['extensions'] };
        const excelBuffer = XLSX.write(wb, { bookType: fileExtension, type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `Extensions_Export.${fileExtension}`);
        return extensions;
      } else {
        throw new Error();
      }
    } catch (error) {
      let errorMessage = 'errorCreatingCSV';
      if (error.message === 'TOO_MANY_TASKS_SAME_TYPE') errorMessage = 'taskAlreadyExecuting';
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
      throw new Error(error);
    }
  };
}

export function saveVirtualIntercomLimits(limits) {
  return {
    type: SAVE_VIRTUAL_INTERCOM_LIMITS,
    limits,
  };
}

export function getVirtualIntercomSubscriptionLimits() {
  return (dispatch, getState) => {
    const { user: { license } } = getState();
    const subscriptions = license && license.subscriptions;
    
    let limits = null;
    
    if (!_.isEmpty(subscriptions)) {
      // Check in priority order: MANAGEMENT > VIDEO > CHECKIN > VOICE
      if (_.find(subscriptions, subscription => subscription.resourceType === SUBSCRIPTION_TYPES.VIRTUAL_INTERCOM_MANAGEMENT)) {
        limits = VIRTUAL_INTERCOM_MANAGEMENT_LIMITS.VIRTUAL_INTERCOM_MANAGEMENT;
      } else if (_.find(subscriptions, subscription => subscription.resourceType === SUBSCRIPTION_TYPES.VIRTUAL_INTERCOM_MANAGEMENT_VIDEO)) {
        limits = VIRTUAL_INTERCOM_MANAGEMENT_LIMITS.VIRTUAL_INTERCOM_MANAGEMENT_VIDEO;
      } else if (_.find(subscriptions, subscription => subscription.resourceType === SUBSCRIPTION_TYPES.VIRTUAL_INTERCOM_MANAGEMENT_CHECKIN)) {
        limits = VIRTUAL_INTERCOM_MANAGEMENT_LIMITS.VIRTUAL_INTERCOM_MANAGEMENT_CHECKIN;
      } else if (_.find(subscriptions, subscription => subscription.resourceType === SUBSCRIPTION_TYPES.VIRTUAL_INTERCOM_MANAGEMENT_VOICE)) {
        limits = VIRTUAL_INTERCOM_MANAGEMENT_LIMITS.VIRTUAL_INTERCOM_MANAGEMENT_VOICE;
      }
    }
    
    // If no virtual intercom subscription found, use most restrictive (VOICE)
    if (!limits) {
      limits = VIRTUAL_INTERCOM_MANAGEMENT_LIMITS.VIRTUAL_INTERCOM_MANAGEMENT_VOICE;
    }
    
    dispatch(saveVirtualIntercomLimits(limits));
    return limits;
  };
}